import styled from "styled-components"

const Pre = styled.pre`
  white-space: break-spaces;
  overflow-wrap: anywhere;
`

export default Pre
